import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {AppPromptData} from '../../interface';
import './app-prompt.scss';

interface AppPromptProps {
    data: AppPromptData
    onClose: () => void;
    onConfirm: () => void;
}


const AppPrompt = ({
                       data: {title, message, confirmButton, declineButton, buttonError},
                       onClose,
                       onConfirm
                   }: AppPromptProps) => {


    return <>
        <Dialog
            className="action-prompt-dialog"
            open={true}
            maxWidth={'sm'}
            onClose={onClose}
        >
            <DialogTitle className="dialog-title">{title}</DialogTitle>
            <DialogContent>
                <ul>
                    {message.map((item, i) => (
                        <li key={i} dangerouslySetInnerHTML={{__html: item}}>
                        </li>
                    ))}
                </ul>
            </DialogContent>
            <DialogActions>
                <Button
                    variant={'outlined'}
                    onClick={onClose}
                >
                    {declineButton || 'Отмена'}
                </Button>
                <Button
                    variant={'contained'}
                    color={buttonError ? 'error' : 'primary'}
                    onClick={onConfirm}
                >
                    {confirmButton}
                </Button>
            </DialogActions>
        </Dialog>
    </>;
};

export {AppPrompt};
